import { render, staticRenderFns } from "./ProcedureItemMobile.vue?vue&type=template&id=1c94dfe9&scoped=true"
import script from "./ProcedureItemMobile.vue?vue&type=script&lang=js"
export * from "./ProcedureItemMobile.vue?vue&type=script&lang=js"
import style0 from "./ProcedureItemMobile.vue?vue&type=style&index=0&id=1c94dfe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94dfe9",
  null
  
)

export default component.exports